import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
    chargeStatuses: [],
    chargeConditions: [],
    acknowledgmentStatuses: [],
    organization: [],
    kbk: [],
    listCharge: { 'results': [] },
    charge: {
      id: null,
      kbk: null
    },
    defaultCharge: {
      id: null,
      payer: null,
      totalAmount: null,
      get_purpose: '',
      deliveryDate: null,
      charge_status: 1,
      charge_status_reason: '',
      charge_condition: 1,
      acknowledgmentStatus: null,
      supplierBillID: '',
      kbk: null,
      ruling_path: '',
      ruling_filename: '',
      ruling_sign_path: '',
      ruling_sign_filename: '',
      discount: null,
      discount_fixed_value: 0,
      discount_fixed_expiry: null,
      discount_sice_value: 0,
      discount_sice_expiry: null,
      multiplier_size_value: 0,
      multiplier_size_expiry: null
    },
    tab: 'tab-1'
  },
  mutations: {
    setChargeStatuses (state, payload) {
      state.chargeStatuses = payload
    },
    setChargeConditions (state, payload) {
      state.chargeConditions = payload
    },
    setAcknowledgmentStatuses (state, payload) {
      state.acknowledgmentStatuses = payload
    },
    setOrganization (state, payload) {
      state.organization = payload
    },
    setKBK (state, payload) {
      state.kbk = payload
    },
    setListCharge (state, payload) {
      state.listCharge = payload
    },
    setCharge (state, payload) {
      state.charge = payload
    },
    setDefaultCharge (state) {
      state.charge = Object.assign({}, state.defaultCharge)
    },
    setTab (state, payload) {
      state.tab = payload
    },
    setDefaultTab (state) {
      state.tab = 'tab-1'
    }
  },
  actions: {
    fetchChargeStatuses ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchChargeStatuses'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'charge-status/'
        session.get(_url)
          .then(response => {
            commit('setChargeStatuses', response.data.results)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchChargeConditions ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchChargeConditions'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'charge-condition/'
        session.get(_url)
          .then(response => {
            commit('setChargeConditions', response.data.results)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchAcknowledgmentStatuses ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpAcknowledgmentStatuses'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'acknowledgment-status/'
        session.get(_url)
          .then(response => {
            commit('setAcknowledgmentStatuses', response.data.results)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchOrganization ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'gis_gmpFetchOrganization', { root: true })
        let _url = URL + 'gis_gmp/api/organization/'
        session.get(_url)
          .then(response => {
            commit('setOrganization', response.data.results)
            commit('common/popLoading', 'fetchOrganization', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchOrganization', { root: true })
            reject(e)
          })
      })
    },
    fetchKBK ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'gis_gmpFetchKBK', { root: true })
        let _url = URL + 'gis_gmp/api/list-kbk/'
        session.get(_url)
          .then(response => {
            commit('setKBK', response.data)
            commit('common/popLoading', 'fetchKBK', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchKBK', { root: true })
            reject(e)
          })
      })
    },
    fetchListCharge ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchListCharge'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        params['payer_id'] = payload.payer_id
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        let _url = appURL + 'charge/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListCharge', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchCharge ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchCharge'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'charge/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setCharge', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertCharge ({ commit, dispatch, getters }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpinsertCharge_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // TODO: Код не очень
        const data = new FormData()
        data.append('payer', payload.payer)
        data.append('totalAmount', payload.totalAmount)
        // data.append('purpose', payload.purpose)
        data.append('charge_status', payload.charge_status)
        data.append('charge_status_reason', payload.charge_status_reason)
        data.append('charge_condition', payload.charge_condition)
        data.append('kbk', payload.kbk)

        if (payload.discount) {
          data.append('discount', payload.discount)
          const discountAbbr = getters.getKBK(payload.kbk).discount_abbr
          if (discountAbbr === 'DiscountFixed') {
            data.append('discount_fixed_value', payload.discount_fixed_value)
            data.append('discount_fixed_expiry', payload.discount_fixed_expiry)
          }
          if (discountAbbr === 'DiscountSize') {
            data.append('discount_sice_value', payload.discount_sice_value)
            data.append('discount_sice_expiry', payload.discount_sice_expiry)
          }
          if (discountAbbr === 'MultiplierSize') {
            data.append('multiplier_size_value', payload.multiplier_size_value)
            data.append('multiplier_size_expiry', payload.multiplier_size_expiry)
          }
        } else {
          data.append('discount', '')
        }

        let _url, method
        if (payload.id === null) {
          _url = appURL + 'charge/'
          method = 'post'
        } else {
          _url = appURL + 'charge/' + payload.id + '/'
          method = 'patch'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setCharge', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertFileCharge ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpinsertFileCharge_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // TODO: Код не очень
        const data = new FormData()
        if (payload.ruling_num) {
          data.append('ruling_num', payload.ruling_num)
        }
        if (payload.ruling_date) {
          data.append('ruling_date', payload.ruling_date)
        }
        if (payload.ruling_path !== null && typeof payload.ruling_path === 'object') {
          data.append('ruling_path', payload.ruling_path)
        }
        if (payload.ruling_sign_path !== null && typeof payload.ruling_sign_path === 'object') {
          data.append('ruling_sign_path', payload.ruling_sign_path)
        }
        let _url, method
        if (payload.id === null) {
          _url = appURL + 'charge/'
          method = 'post'
        } else {
          _url = appURL + 'charge/' + payload.id + '/'
          method = 'patch'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setCharge', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteCharge ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpdeleteCharge_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'charge/' + payload + '/delete/'
        session.get(_url)
          .then(function () {
            commit('setDefaultCharge')
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpdeleteFile_' + payload.id + payload.fileType
        let url2 = ''
        if (payload.fileType === 'ruling') {
          url2 = '/delete_ruling_file/'
        }
        if (payload.fileType === 'ruling_sign') {
          url2 = '/delete_ruling_sign_file/'
        }
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'charge/' + payload.id + url2
        session.get(_url)
          .then(response => {
            commit('setCharge', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    chargeStatuses (state) {
      return state.chargeStatuses
    },
    getChargeStatus: (state) => (id) => {
      let item = {
        id: null,
        status: ''
      }
      for (let i in state.chargeStatuses) {
        if (state.chargeStatuses[i]['id'] === id) {
          item = state.chargeStatuses[i]
          break
        }
      }
      return item
    },
    chargeConditions (state) {
      return state.chargeConditions
    },
    getChargeCondition: (state) => (id) => {
      let item = {
        id: null,
        condition: ''
      }
      for (let i in state.chargeConditions) {
        if (state.chargeConditions[i]['id'] === id) {
          item = state.chargeConditions[i]
          break
        }
      }
      return item
    },
    getAcknowledgmentStatus: (state) => (id) => {
      let item = {
        id: null,
        name: ''
      }
      for (let i in state.acknowledgmentStatuses) {
        if (state.acknowledgmentStatuses[i]['id'] === id) {
          item = state.acknowledgmentStatuses[i]
          break
        }
      }
      return item
    },
    organization (state) {
      return state.organization
    },
    kbk (state) {
      return state.kbk.map(function (item) {
        item['fullCaption'] = `№: ${item.id}, Код: ${item.name}, Статья: ${item.koap_item}, Расшифровка: ${item.caption}`
        return item
      })
    },
    getKBK: (state) => (id) => {
      return state.kbk.filter(item => item.id === id)[0]
    },
    listCharge (state) {
      return state.listCharge
    },
    charge (state) {
      return state.charge
    },
    urlQuittance: () => (id) => {
      return appURL + 'charge/' + id + '/get_quittance_html/'
    },
    tab (state) {
      return state.tab
    }
  }
}
